import Modal from '@mui/material/Modal';
import { Link } from 'react-router-dom';
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

import 'react-circular-progressbar/dist/styles.css';
import { updateUser } from '../../reducers/userReducer';
import AnimatedPage from "../../components/AnimatedPage";
import { toggleModal } from "../../reducers/modalReducer";
import { BILLING, COMPANY } from "../../constants/routes";
import Certification from "../../components/Certification";
import { refreshCompanies } from '../../reducers/companiesReducer';
import { getRequest, postRequest, showMessage } from "../../config";
import PassFailCertification from "../../components/PassFailCertification";
import HeadingSubheadingContent from "../../components/HeadingSubheadingContent";


export default function Dashboard() {

	const dispatch = useDispatch();
	const location = useLocation();
	const navigation = useNavigate();

	const user = useSelector(state => state.user);
	const modal = useSelector(state => state.modal);
	const companies = useSelector(state => state.companies);

	const [noCompanies, setNoCompanies] = useState(false);
	const [profileClass, setProfileClass] = useState('client-profile');

	const SEE_MORE = {
		icon: <svg width="83" height="83" viewBox="0 0 84 83" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M33.9088 30H12.0907C9.28355 30 7 27.7432 7 24.9684V12.031C7 9.25678 9.28355 7 12.0907 7H33.9088C36.7165 7 39 9.25678 39 12.031V24.9684C39 27.7432 36.7165 30 33.9088 30ZM12.0907 11.3125C11.6896 11.3125 11.3636 11.6346 11.3636 12.031V24.9684C11.3636 25.3654 11.6896 25.6875 12.0907 25.6875H33.9088C34.3104 25.6875 34.6364 25.3654 34.6364 24.9684V12.031C34.6364 11.6346 34.3104 11.3125 33.9088 11.3125H12.0907Z" fill="#4A67FF" />
			<path d="M33.9088 76H12.0907C9.28355 76 7 73.7572 7 71.0002V41.0003C7 38.2428 9.28355 36 12.0907 36H33.9088C36.7165 36 39 38.2428 39 41.0003V71.0002C39 73.7572 36.7165 76 33.9088 76ZM12.0907 40.2857C11.6896 40.2857 11.3636 40.6059 11.3636 41.0003V71.0002C11.3636 71.3941 11.6896 71.7143 12.0907 71.7143H33.9088C34.3104 71.7143 34.6364 71.3941 34.6364 71.0002V41.0003C34.6364 40.6059 34.3104 40.2857 33.9088 40.2857H12.0907Z" fill="#4A67FF" />
			<path d="M71.0684 76H49.9321C47.2122 76 45 73.7432 45 70.969V58.0316C45 55.2568 47.2122 53 49.9321 53H71.0684C73.7878 53 76 55.2568 76 58.0316V70.969C76 73.7432 73.7878 76 71.0684 76ZM49.9321 57.3125C49.5431 57.3125 49.2272 57.6346 49.2272 58.0316V70.969C49.2272 71.3654 49.5431 71.6875 49.9321 71.6875H71.0684C71.4569 71.6875 71.7728 71.3654 71.7728 70.969V58.0316C71.7728 57.6346 71.4569 57.3125 71.0684 57.3125H49.9321Z" fill="#4A67FF" />
			<path d="M71.0684 47H49.9321C47.2122 47 45 44.7572 45 41.9997V11.9998C45 9.24277 47.2122 7 49.9321 7H71.0684C73.7878 7 76 9.24277 76 11.9998V41.9997C76 44.7572 73.7878 47 71.0684 47ZM49.9321 11.2857C49.5431 11.2857 49.2272 11.6059 49.2272 11.9998V41.9997C49.2272 42.3941 49.5431 42.7143 49.9321 42.7143H71.0684C71.4569 42.7143 71.7728 42.3941 71.7728 41.9997V11.9998C71.7728 11.6059 71.4569 11.2857 71.0684 11.2857H49.9321Z" fill="#4A67FF" />
		</svg>,
		title: <>Your Company<br /> Dashboard</>,
		points: [
			'All your modules in one place',
			'Overall completeness and risk scores',
			'Overall certification (broze/silver/gold)',
			'At-a-glance module progress and status',
			'Access to reports for each module',
			'Easy one-stop shop for your advisors and Investors to work collaboratively with you',
		],
		image: require('../../../images/landingpage/banner1.png'),
		imageStyle: { height: '90%', width: '94%' }
	};

	useEffect(() => {
		getCompanies();
		if (location.pathname.includes('gDriveCallBack')) connectGDrive();
		else if (location.pathname.includes('dropBoxCallBack')) connectDropBox();
		else if (location.pathname.includes('sharePointCallBack')) connectSharePoint();
		if (user) setProfileClass(user['role'] == 'Advisor' ? 'advisor-profile' : user['role'] == 'Investor' ? 'investor-profile' : 'client-profile');

		let isWorkflowTab = localStorage.getItem('isWorkflowTab');
		if (isWorkflowTab) localStorage.removeItem('isWorkflowTab');
	}, []);

	const getCompanies = async () => {
		let response = await getRequest(`/user/myProfile`);
		if (response['body']) {
			let { user, companies } = response['body'];
			let groups = companies.filter(({ group }) => group == 'Parent');
			let standard = companies.filter(({ group }) => group != 'Parent');
			companies = groups.concat(standard);

			if (companies.length == 0) setNoCompanies(true);

			dispatch(updateUser(user));
			dispatch(refreshCompanies(companies));
		};
	};

	const connectGDrive = async () => {
		let { code, state: companyId } = urlSearchData(location['search']);
		dispatch(toggleModal({ open: 'connectDataRoom' }));
		const response = await postRequest(`/company/connectGDrive`, { code, companyId });
		if (response) {
			showMessage(response['message']);
			setTimeout(() => navigation(`/company/${companyId}#repository`), 1000);
		}
	};

	const connectDropBox = async () => {
		let { code, state: companyId } = urlSearchData(location['search']);
		dispatch(toggleModal({ open: 'connectDataRoom' }));
		const response = await postRequest(`/company/connectDropBox`, { code, companyId });
		if (response) {
			showMessage(response['message']);
			setTimeout(() => navigation(`/company/${companyId}`), 1000);
		};
	};

	const connectSharePoint = async () => {
		let { code, state: companyId, client_info } = urlSearchData(location['search']);
		dispatch(toggleModal({ open: 'connectDataRoom' }));
		const response = await postRequest(`/company/connectSharePoint`, { code, companyId, client_info });
		if (response) {
			showMessage(response['message']);
			setTimeout(() => navigation(`/company/${companyId}`), 1000);
		};
	};

	const urlSearchData = searchString => {
		if (!searchString) return {};
		return searchString.substring(1).split('&').reduce((result, next) => {
			let pair = next.split('=');
			result[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
			return result;
		}, {});
	};

	const showCompanyDetails = (company) => {
		return <>
			<div className="df w400px">
				{user['emailVerified'] && company['progress'] != 'pending' && company['subscription'] &&
					<Link data-tooltip={"Company Settings"} to={`/company/${company['_id']}#company-settings`} className="pr cp w3rem h3rem df jcc br10px c1 c6 usn bsbb p0-5rem td250 c4-hover ass mr1rem bg1">
						<svg data-tooltip={"Company Settings"} className="center-vertically f3 l0 w2rem h2rem pr" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path data-tooltip={"Company Settings"} d="M28.21 10.8405C27.6265 10.7557 27.0696 10.5404 26.5809 10.2106C26.0921 9.88078 25.684 9.44496 25.387 8.93557C25.0901 8.42618 24.9118 7.85636 24.8656 7.26853C24.8193 6.68071 24.9063 6.09003 25.12 5.54048C25.2559 5.1812 25.2759 4.78842 25.1772 4.4172C25.0786 4.04598 24.8663 3.71494 24.57 3.47048C23.2621 2.37214 21.7733 1.50932 20.17 0.920477C19.8049 0.78486 19.4064 0.767915 19.0311 0.872057C18.6558 0.9762 18.323 1.19612 18.08 1.50048C17.7143 1.96813 17.2469 2.34636 16.7132 2.60649C16.1796 2.86662 15.5937 3.0018 15 3.0018C14.4063 3.0018 13.8205 2.86662 13.2868 2.60649C12.7532 2.34636 12.2857 1.96813 11.92 1.50048C11.677 1.19612 11.3442 0.9762 10.9689 0.872057C10.5937 0.767915 10.1951 0.78486 9.83002 0.920477C8.34969 1.46412 6.96561 2.24055 5.73002 3.22048C5.41857 3.46704 5.19423 3.80684 5.08986 4.19013C4.98549 4.57341 5.00657 4.98004 5.15002 5.35048C5.38078 5.91457 5.47612 6.52489 5.42839 7.13248C5.38067 7.74007 5.19121 8.32802 4.87522 8.84916C4.55923 9.37031 4.1255 9.81014 3.60881 10.1334C3.09213 10.4566 2.50689 10.6543 1.90002 10.7105C1.50603 10.7526 1.13597 10.9201 0.844333 11.1884C0.552693 11.4566 0.354882 11.8114 0.280022 12.2005C0.0938193 13.1222 2.16404e-05 14.0602 2.16404e-05 15.0005C-0.00134695 15.7877 0.0622018 16.5737 0.190022 17.3505C0.253637 17.752 0.447768 18.1215 0.742402 18.4017C1.03704 18.6818 1.41576 18.8571 1.82002 18.9005C2.44022 18.9587 3.03745 19.1646 3.56173 19.501C4.08601 19.8374 4.52208 20.2945 4.83345 20.834C5.14482 21.3735 5.32243 21.9797 5.35141 22.602C5.38039 23.2242 5.2599 23.8444 5.00002 24.4105C4.82995 24.7787 4.78776 25.1932 4.88016 25.5882C4.97256 25.9831 5.19424 26.3359 5.51002 26.5905C6.81014 27.6689 8.28459 28.5177 9.87002 29.1005C10.0728 29.1707 10.2855 29.2078 10.5 29.2105C10.7942 29.2098 11.0839 29.1387 11.3449 29.003C11.6059 28.8672 11.8306 28.6709 12 28.4305C12.3564 27.9112 12.8342 27.4867 13.3919 27.194C13.9495 26.9012 14.5702 26.749 15.2 26.7505C15.8103 26.7512 16.4119 26.8945 16.957 27.1688C17.5022 27.4431 17.9757 27.8409 18.34 28.3305C18.5823 28.6562 18.9256 28.8926 19.3162 29.003C19.7069 29.1133 20.1231 29.0913 20.5 28.9405C21.9497 28.357 23.2993 27.5506 24.5 26.5505C24.8016 26.3011 25.0164 25.9625 25.1134 25.5834C25.2105 25.2042 25.1848 24.8041 25.04 24.4405C24.8048 23.8837 24.7023 23.2798 24.7405 22.6765C24.7786 22.0733 24.9565 21.4872 25.2601 20.9645C25.5636 20.4417 25.9845 19.9967 26.4895 19.6646C26.9945 19.3324 27.5698 19.1222 28.17 19.0505C28.5592 18.9967 28.9212 18.8203 29.2034 18.5471C29.4857 18.2738 29.6736 17.9177 29.74 17.5305C29.9006 16.6964 29.9876 15.8498 30 15.0005C30.0002 14.1046 29.9165 13.2107 29.75 12.3305C29.6825 11.9518 29.4974 11.604 29.2209 11.3365C28.9445 11.069 28.5907 10.8955 28.21 10.8405ZM20 15.0005C20 15.9894 19.7068 16.9561 19.1574 17.7783C18.608 18.6006 17.8271 19.2414 16.9134 19.6199C15.9998 19.9983 14.9945 20.0973 14.0246 19.9044C13.0547 19.7115 12.1638 19.2353 11.4645 18.536C10.7652 17.8367 10.289 16.9458 10.0961 15.9759C9.90317 15.006 10.0022 14.0007 10.3806 13.0871C10.7591 12.1734 11.3999 11.3925 12.2222 10.8431C13.0444 10.2937 14.0111 10.0005 15 10.0005C16.3261 10.0005 17.5979 10.5273 18.5356 11.4649C19.4732 12.4026 20 13.6744 20 15.0005Z" fill="#4A67FF" />
						</svg>
					</Link>
				}
				<div className="df fdc jcfs tal">
					<h4 className='fs1-25rem c15 mb1rem w300px'>{company['cName']}</h4>
					<span className='df w300px'>
						{company['subscription']
							? <h2 className="fs1rem c7 mra tal mr1rem">
								{((company?.['creatorId']?.['createdBy']?.['role'] == 'Advisor' || company?.['creatorId']?.['createdBy']?.['role'] == 'Investor') && (company['advisors'] || company['investors']) && company['subscription'] == 'Pro')
									? 'Portfolio PRO'
									: <>{company['subscription']}</>
								}</h2>
							: <h2 className="fs1rem c8 mr1rem tal">INACTIVE</h2>
						}
						{company['subscription']
							? <Link to={BILLING.replace(":id", company['_id'])} className={`${user['email'] == 'temp' && 'op20 pen '} tac bg0 br50px bw2px bss py0-5rem px1rem bsbb aic cp bo3 c3 fs0-75rem`}>Upgrade</Link>
							: <Link data-testid="subscribeNow" to={BILLING.replace(":id", company['_id'])} className="tac bg4 br50px bw2px bss py0-5rem px1rem bsbb aic cp bo4 c1 fs0-75rem">Subscribe Now</Link>
						}
					</span>
				</div>
			</div >
			<div className="df m1rem jcc">
				<div className="df jcse w60px mr2rem">
					<span className="w20 df jcc username-area tac mr2rem">
						<div class="df fdc aic">
							{company?.['creatorId']?.['profile']
								? <img src={company['creatorId']['profile']} className={`w40px h40px df jcc aic br100 cp bo30 bss bw3px ${profileClass}`} data-tooltip={company['creatorId']['firstName'] ? (company['creatorId']['firstName'] + " " + (company['creatorId']?.['lastName'] ?? "")) : "Register to show your name here"} />
								: <span className={`w40px h40px df jcc aic br100 bg3 c1 bw3px bss bo30 c1 ${profileClass}`} data-tooltip={company['creatorId']['firstName'] ? (company['creatorId']['firstName'] + " " + (company['creatorId']?.['lastName'] ? company['creatorId']?.['lastName'] : "")) : "Register to show your name here"}>{company['creatorId']['firstName'] ? (company['creatorId']['firstName'][0] + (company['creatorId']?.['lastName'] ? company['creatorId']?.['lastName']?.[0] : "")) : "?"}</span>
							}
							<span class="ass mt0-5rem fs0-75rem c15">Company <br />Admin</span>
						</div>
					</span>
				</div>
				<div className="df jcse w60px mr2rem">
					<span className='w20 df username-area type-user mr2rem'>
						<div className="df fdc">
							<span onClick={() => dispatch(toggleModal({ open: 'userDetail' }))} data-tooltip={(company['group'] && company['group'] !== "Standard") ? company['group'] : 'Not Connected'} className={`w40px h40px df jcc aic br100 bg4 c1 bo4 bss bw3px mb1rem ${company['group'] ? 'fs1rem' : 'fs0-75rem'}`}>
								{(company['group'] && company['group'] !== "Standard") ? company['group'][0] : 'N/A'}
							</span>
							<span className="ass mt0-5rem fs0-75rem c15">Group</span>
						</div>
					</span>
				</div>
			</div>
			<div className="df jcse aic fdc reprot-btn-dropdowns">
				<Link to={COMPANY.replace(":id", company['_id'])}
					className={`${!company['subscription'] && 'op20 pen '} tac dashboard-btn c1 bg-gradient2 bg-gradient-hover br20px px0-25rem py0-5rem fs0-75rem fw500 mr0-5rem w100 td250`}>
					Company Dashboard
				</Link>
			</div>
			<div className="progress-area progress-dashboard" style={{ display: "flex", position: "relative", justifyContent: "center", }}>
				<div className="progress-box ml2rem mr1rem">
					<div className="progress-bar" style={{ width: 100, height: 100 }}>
						<CircularProgressbar
							className={`${company.stats.completionPercent > 67 ? 'green'
								: company.stats.completionPercent > 33 ? 'orange'
									: 'red'}`}
							value={company.stats.completionPercent || 0}
							text={(company.stats.completionPercent || 0) + "%"}
							strokeWidth={18}
							styles={buildStyles({
								strokeLinecap: 'round',
								strokeWidth: '5px',
								textSize: '20px',
								pathTransitionDuration: 0.5,
								trailColor: '#d6d6d6',
								backgroundColor: '#fc7785',
								dominantBaseline: 'ideographic',
							})}
						/>
					</div>
					<div className="bottom-text df fdc tac jcc mt0-5rem">
						<span className="fs0-5rem fw300 c15">
							Overall
						</span>
						<span style={{ marginBottom: "0", }} className="text-center-area c15 fs1rem fw400">
							Completeness
						</span>
					</div>
				</div>
				<div className="progress-box ml2rem mr1rem">
					<div className="progress-bar" style={{ width: 100, height: 100 }}>
						<CircularProgressbar
							className={`${company.stats.riskPercent > 67 ? 'red'
								: company.stats.riskPercent > 33 ? 'orange'
									: 'green'}`}
							value={company.stats.riskPercent || 0}
							text={company.stats.completionPercent ? `${(company.stats.riskPercent || 0)}%` : "0%"}
							strokeWidth={18}
							styles={buildStyles({
								strokeLinecap: 'butt',
								strokeWidth: '5px',
								textSize: '20px',
								pathTransitionDuration: 0.5,
								trailColor: '#d6d6d6',
								backgroundColor: '#fc7785',
								dominantBaseline: 'ideographic',
							})}
						/>
					</div>
					<div className="bottom-text df fdc tac jcc mt0-5rem">
						<span className="fs0-5rem fw300 c15">
							Overall
						</span>
						<span style={{ marginBottom: "0", }} className="text-center-area c15 fs1rem fw400">
							Risk
						</span>
					</div>
				</div>
				{company['subscription'] == 'Pro' &&
					<Link onClick={() => localStorage.setItem('isWorkflowTab', true)} to={`/company/${company['_id']}`} className="cp progress-box ml2rem mr1rem df fdc aic">
						<div className={`progress-bar workflow-report-progress ${company?.stats?.workflowCompletionPercent > 75 ? 'workflow-progress-green' : company?.stats?.workflowCompletionPercent > 26 ? 'workflow-progress-yellow' : company?.stats?.workflowCompletionPercent > 1 ? ' workflow-progress-pink' : '  workflow-progress-grey'}`}
							style={{ width: 80, height: 80, borderRadius: '50%', margin: 0, border: '2px solid #F1F1F1' }}>
							<CircularProgressbar
								text={(company?.stats?.workflowCompletionPercent || 0) + "%"}
								styles={buildStyles({
									strokeWidth: '0',
									textSize: '20px',
									trailColor: '#FBFBFB',
									stroke: 'transparent',
									strokeLinecap: 'butt',
									backgroundColor: '#FBFBFB',
									pathTransitionDuration: 0.5,
									dominantBaseline: 'ideographic',
								})}
							/>
						</div>
						<div className="bottom-text df fdc tac jcc mt0-5rem">
							<span className="fs0-5rem fw300 c15">
								Overall
							</span>
							<span style={{ marginBottom: "0", }} className="text-center-area c15 fs1rem fw400">
								Workflow Completeness
							</span>
						</div>
					</Link>
				}
			</div>
			<div class="df jcse mt0-5rem">
				<div className="certificate-area-dashboard">
					{(company['cLevel']) && (company['subscription'] == "Pro" || company['subscription'] == "Pro Plus") &&
						<>{company['subscription'] == "Free" || user['role'] == 'Guest'
							? <PassFailCertification className={'op100'} testType={company['testType']} level={company?.moduleCertification?.['two-minute-test-' + company['testType']]} expiryTimestamp={company['createdAt']} company={company} subscription={company['subscription']} />
							: <Link data-tooltip="Certification" to={`/company/${company['_id']}#unaudited-certification`} className="cp">
								<Certification className={'op100'} level={company['subscription'] == "Lite" ? 'None' : company['cLevel']} expiryTimestamp={company['createdAt']} company={company} subscription={company['subscription']} />
							</Link>
						}</>
					}
				</div>
			</div>
		</>
	};

	return (
		<>
			<AnimatedPage>
				<div className="dashboard-container company-dashboard pt2rem pb1rem df fdc poppins-font-style * ">
					<div className={`banner-advisor-dashboard pr w100 mt2rem mb1rem company-bg`}>
						<div className={` bg1 new-shadow br20px py2rem px3rem my2rem pr`}>
							<div className='df jce w100 aic top-admin-area'>
								<div className='right-area df'>
									<div className="ass df">
										{/* Owner */}
										<div className="df fs1rem aic">
											<div className='mr1rem tar df fdc'>
												{user?.['firstName'] && <span className="c15 ase">{user?.['firstName'] + " " + (user?.['lastName'] ?? "")}</span>}
												{user?.['companyId']?.['creatorId']?.['_id'] == user['_id'] && <span className={`c4 ase fs0-75rem`}>Company Admin</span>}
											</div>
											{user?.['firstName'] &&
												<span className={`w40px h40px df jcc aic br100 bg3 c1 bw3px bss bo30`}>
													{user?.['profile']
														? <img src={user?.['profile']} className={`w40px h40px df jcc aic br100`} data-tooltip={user?.['firstName'] + " " + (user?.['lastName'] ?? "")} />
														: <span className={`w30px h30px df jcc aic br100`} data-tooltip={user?.['firstName'] + " " + (user?.['lastName'] ?? "")}>{user?.['firstName'] ? (user?.['firstName']?.[0] + (user?.['lastName'] ? user?.['lastName']?.[0] : "")) : "?"}</span>
													}</span>
											}
										</div>
									</div>
								</div>
							</div>
							<div className='df fww company-details-area'>
								<div className='center-logo-area w100 df jcc fww pr'>
									<h2 className='c15 fs2rem mt1rem tac w100 fw500 pr df aifs jcc'>
										<i className='icon mr1rem cp pr' onClick={() => dispatch(toggleModal({ open: 'openSeeMore' }))}>
											<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
												<g clip-path="url(#clip0_2634_5425)">
													<path d="M11 22C17.0656 22 22 17.0656 22 11C22 4.9344 17.0656 0 11 0C4.9344 0 0 4.9344 0 11C0 17.0656 4.9344 22 11 22ZM11 2.2C15.8522 2.2 19.8 6.14775 19.8 11C19.8 15.8522 15.8522 19.8 11 19.8C6.14775 19.8 2.2 15.8522 2.2 11C2.2 6.14775 6.14775 2.2 11 2.2ZM9.9 16.5V9.9C9.9 9.29255 10.3926 8.8 11 8.8C11.6074 8.8 12.1 9.29255 12.1 9.9V16.5C12.1 17.1069 11.6074 17.6 11 17.6C10.3926 17.6 9.9 17.1069 9.9 16.5ZM11 7.7C10.3925 7.7 9.9 7.20754 9.9 6.6C9.9 5.99247 10.3925 5.5 11 5.5C11.6075 5.5 12.1 5.99247 12.1 6.6C12.1 7.20754 11.6075 7.7 11 7.7Z" fill="#59B8FD" />
												</g>
												<defs>
													<clipPath id="clip0_2634_5425">
														<rect width="22" height="22" fill="white" />
													</clipPath>
												</defs>
											</svg>
										</i>
										<HeadingSubheadingContent wrapperClass="tac" heading="Company Index" subheading="Company Status" />
									</h2>
								</div>
							</div>
						</div>
					</div>
					<div className='dahboard-tabs'>
						<div className='MuiTabPanel-root'>
							<div className="container df fdc">
								<div className='df fdc aic advisor-index mt1rem'>
									<div className="df jcsb pt1rem pl6rem pr8rem w100">
										{user['email'] != 'temp' && <>
											<div className="df">
												<div onClick={() => { dispatch(toggleModal({ open: 'disclaimerModal' })); localStorage.removeItem('testType'); }} className="df bg1 br50px mr0-5rem bw2px bss pr1rem p0-5rem bsbb aic mr1rem cp add-btn-dashboard">
													<span className='bg1 bsbb mr0-5rem br100 w40px h40px tac df jcc aic'>
														<svg className='h30px w30px' width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
															<g clip-path="url(#clip0_2656_879)">
																<path d="M19 0C8.52298 0 0 8.52298 0 19C0 29.477 8.52298 38 19 38C29.477 38 38 29.477 38 19C38 8.52298 29.477 0 19 0Z" fill="#4A67FF" />
																<path d="M27.3098 20.5825H20.5805V27.3118C20.5805 28.1859 19.8714 28.895 18.9973 28.895C18.1232 28.895 17.4141 28.1859 17.4141 27.3118V20.5825H10.6848C9.8107 20.5825 9.10156 19.8734 9.10156 18.9993C9.10156 18.1252 9.8107 17.416 10.6848 17.416H17.4141V10.6868C17.4141 9.81265 18.1232 9.10352 18.9973 9.10352C19.8714 9.10352 20.5805 9.81265 20.5805 10.6868V17.416H27.3098C28.1839 17.416 28.893 18.1252 28.893 18.9993C28.893 19.8734 28.1839 20.5825 27.3098 20.5825Z" fill="#FAFAFA" />
															</g>
															<defs>
																<clipPath id="clip0_2656_879">
																	<rect width="38" height="38" fill="white" />
																</clipPath>
															</defs>
														</svg>
													</span>
													<span className='c15'>Add Company</span>
												</div>
												<div onClick={() => dispatch(toggleModal({ open: 'groupCompanies' }))} className={`${companies && companies.length <= 1 && 'op20 pen '} df bg1 br50px mr0-5rem bw2px bss pr1rem p0-5rem bsbb aic mr1rem cp add-btn-dashboard`}>
													<span className='bg1 bsbb mr0-5rem br100 w40px h40px tac df jcc aic'>
														<svg className='h30px w30px' width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
															<g clip-path="url(#clip0_2656_879)">
																<path d="M19 0C8.52298 0 0 8.52298 0 19C0 29.477 8.52298 38 19 38C29.477 38 38 29.477 38 19C38 8.52298 29.477 0 19 0Z" fill="#4A67FF" />
																<path d="M27.3098 20.5825H20.5805V27.3118C20.5805 28.1859 19.8714 28.895 18.9973 28.895C18.1232 28.895 17.4141 28.1859 17.4141 27.3118V20.5825H10.6848C9.8107 20.5825 9.10156 19.8734 9.10156 18.9993C9.10156 18.1252 9.8107 17.416 10.6848 17.416H17.4141V10.6868C17.4141 9.81265 18.1232 9.10352 18.9973 9.10352C19.8714 9.10352 20.5805 9.81265 20.5805 10.6868V17.416H27.3098C28.1839 17.416 28.893 18.1252 28.893 18.9993C28.893 19.8734 28.1839 20.5825 27.3098 20.5825Z" fill="#FAFAFA" />
															</g>
															<defs>
																<clipPath id="clip0_2656_879">
																	<rect width="38" height="38" fill="white" />
																</clipPath>
															</defs>
														</svg>
													</span>
													<span className='c15'>Create Group</span>
												</div>
											</div>
										</>}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className='dahboard-tabs'>
					<div className='MuiTabPanel-root'>
						<div className="container pb2rem df fdc">
							<div className='df fdc aic advisor-index'>
								{companies && companies.length > 0
									? companies.map((company, idx) => {
										return (
											<div key={idx} className="dropdown-company-dahboard">
												<div className="dg gtcr5-md gg1rem py0-5rem px2rem br20px aic bg29 fs1rem mb2rem company-dashboard-sf" style={{ border: '1px solid #7385BE50', backgroundColor: '#F0F2FD50' }}>
													{showCompanyDetails(company)}
												</div>
												{company['childrenCompanies'] && company['childrenCompanies'].length > 0 && <>
													<div className="dropdown-content">
														{company['childrenCompanies'] && company['childrenCompanies'].map((childrenCompany, idx) => {
															return (
																<div key={idx} className="dg gtcr5-md gg1rem py0-5rem px2rem br20px aic bg29 fs1rem mb2rem company-dashboard-sf" style={{ border: '1px solid #7385BE50', backgroundColor: '#F0F2FD50' }}>
																	{showCompanyDetails(childrenCompany)}
																</div>
															)
														})}
													</div>
												</>}
											</div>
										)
									})
									: <>{noCompanies && <h1 className='tac text-gradient fs1-75rem pt1rem pb3rem lh2'>No Companies Added</h1>}</>
								}
							</div>
						</div>
					</div>
				</div>
			</AnimatedPage>

			{/* User Detail */}
			<Modal open={modal['open'] == 'userDetail'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic" >
				<div className="mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr">
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<h1 className="text-gradient fs3rem tac lh1 fw600 mb2rem">Owner Detail</h1>
					<div className='df fdc iic mxa gg0-5rem'>
						<span className='w100' ><b>Name: &nbsp;</b> {user?.firstName + (user?.lastName ?? "")} </span>
						<span className='w100'><b>Email: &nbsp;</b> {user?.email} </span>
						<span className='w100'><b>Role: &nbsp;</b> {user?.role} </span>
					</div>
				</div>
			</Modal>

			{/* See More Popup */}
			<Modal id="keyFeatureSeeMore" open={modal['open'] == 'openSeeMore'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic" >
				<div className="poppins-font-style mah100 bg1 shadow w100 p4rem df fdc m1rem pr br10px pr" style={{ outline: 'none', paddingBottom: '2rem', maxWidth: '1350px' }}>
					<div className='df w100' >
						<div style={{ width: "55%", height: '100%' }}>
							<div className='df w100 mb1rem'>
								<div className="w10 df aic">{SEE_MORE?.icon}</div>
								<div className="w90 fw500 c15 pl1rem df aic" style={{ fontSize: '26px', lineHeight: '37.32px' }}>{SEE_MORE?.title}</div>
							</div>
							{/* custom-list */}
							<ul class=" mt0-5rem" style={{ paddingLeft: '22px' }}>
								{SEE_MORE?.points?.map((objpoints, index) => {
									return (
										<li style={{ lineHeight: '25px', paddingBottom: "3px", paddingTop: "3px", paddingLeft: "20px", borderLeft: '2px solid #D3D9FC', ...SEE_MORE?.liStyle }} className="df fdc fs1rem c14 fs1rem fw400" key={`${objpoints}-${index}`}>
											<div className="pr"><div className="circle"></div>{objpoints}</div>
										</li>
									)
								})}
							</ul>
						</div>
						<div className="df aic jce" style={{ width: '45%' }}>
							<img src={SEE_MORE?.image} className="w70" style={{ objectFit: 'fill' }} />
						</div>
					</div>
					<svg className="pa cp" onClick={() => dispatch(toggleModal({ open: '' }))} style={{ left: '650px', bottom: '-80px' }} width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect opacity="0.8" x="4" y="4" width="52" height="52" rx="26" fill="#151313" />
						<path d="M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z" fill="white" />
					</svg>
				</div>
			</Modal >
		</>
	);
}